import SelectWithButtons from "../../components/support/sliderSupport";
/**
 * SupportMessagePage
 *
 * صفحه نمایش پیام‌های پشتیبانی کاربران. رندر کامپوننت SelectWithButtons که شامل اسلایدر و دکمه‌های مربوط به پیام‌های پشتیبانی است.
 *
 * @returns JSX.Element
 */
// Task Response:

// کد درست است و کامپوننت SelectWithButtons به صورت مستقیم رندر می‌شود.
// هیچ تغییر یا بهینه‌سازی اضافی لازم نیست مگر نیاز به استایل یا مدیریت state داشته باشید.


const SupportMessagePage = () => {
  return <SelectWithButtons />;
};

export default SupportMessagePage;
